import React, { useEffect } from 'react'
import { images } from 'Assets/Images'
import {
  CheckCircleFill,
  PencilSquare,
  XCircleFill,
} from 'react-bootstrap-icons'
import { usePrinterContext } from 'state/context/PrinterTemplatesContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { useGetCmfCredit } from '../../../hooks/useGetCmfCredit'
import { FormatMoney } from 'Utils/functions'
import { disclaimers } from 'Views/PrinterPreview/constants'

export const DEFAULT_VALUE = disclaimers.regularCmf

export const Square1 = ({ products, i }) => {
  const { currentPage, allTemplatesContent, setAllTemplatesContent } =
    usePrinterContext()

  const currentContent = allTemplatesContent.find(
    content => content.page === currentPage
  )
  const currentTerms = currentContent?.content?.terms || DEFAULT_VALUE

  const { fetchCmfCredit, loading } = useGetCmfCredit()
  const [isEditing, setIsEditing] = React.useState(false)
  const [terms, setTerms] = React.useState(currentTerms)

  const prod = products?.content?.products?.[0]
  const prodBasePrice = FormatMoney(prod?.BasePrice || 0)

  const handleEditTerms = () => {
    const updatedContent = allTemplatesContent.map(content => {
      if (content.page === currentPage) {
        return {
          ...content,
          content: {
            ...content.content,
            terms,
          },
        }
      }
      return content
    })
    setAllTemplatesContent(updatedContent)
    setIsEditing(false)
  }

  useEffect(() => {
    if (prod?.Sku && !prod?.cmfCredit) {
      fetchCmfCredit(prod?.BasePrice, prod?.Sku)
    }
  }, [prod?.Sku])

  return (
    <div
      id="printer-preview-left-canvas"
      data-testid="printer-preview-left-canvas"
      className="printer-preview-left-canvas">
      <div className="printer-preview-left-content-body">
        <p className="printer-preview-left-content-body-title">
          {prod?.ProductName || ''}
        </p>
        <p className="printer-preview-left-content-body-sku">
          {prod?.Sku || ''}
        </p>
        {prod?.BasePrice && (
          <div className="printer-preview-left-content-body-price-wrapper">
            <p className="printer-preview-mini-text">$</p>
            <p className="printer-preview-left-content-body-price">
              {prodBasePrice?.toString()?.split('.')?.[0] || ''}.
            </p>
            <p className="printer-preview-mini-text">
              {prodBasePrice?.toString()?.split('.')?.[1] || '00'}
            </p>
          </div>
        )}
      </div>
      <div className="printer-preview-left-content-footer">
        <div className="printer-preview-left-content-footer-quotes">
          <p></p>
          <p className="printer-preview-left-content-footer-quote-text">
            36 <br /> cuotas
          </p>
          <p className="printer-preview-left-content-footer-quote-text">
            {!loading && '$' + (FormatMoney(prod?.cmfCredit || 0) || '')}
            {loading && (
              <FontAwesomeIcon
                icon={faSpinner}
                className="spinner"
                data-testid="spinner"
                style={{ width: 20 }}
              />
            )}
          </p>
        </div>
        <div className="printer-preview-content-footer-input-wrapper template-terms-wrapper-to-remove">
          {isEditing && (
            <textarea
              className="printer-preview-left-content-footer-legal-1"
              type="text"
              value={terms}
              disabled={!isEditing}
              onChange={e => setTerms(e.target.value)}
              style={{
                border: isEditing ? '1px solid #000' : 'none',
                height: '30px',
              }}
            />
          )}
          {!isEditing && (
            <p
              className="printer-preview-left-content-footer-legal-1"
              style={{
                border: isEditing ? '1px solid #000' : 'none',
                height: '30px',
              }}>
              {terms}
            </p>
          )}
          <div className="printer-terms-edit-wrapper-1">
            {isEditing && (
              <CheckCircleFill
                onClick={handleEditTerms}
                data-testid="confirmEdit"
                className="printer-preview-content-check"
              />
            )}
            {isEditing && (
              <XCircleFill
                onClick={() => {
                  setIsEditing(false)
                  setTerms(DEFAULT_VALUE)
                }}
                className="printer-preview-content-circle"
              />
            )}
            {!isEditing && (
              <PencilSquare
                data-testid="pencil"
                onClick={() => setIsEditing(true)}
                className="printer-preview-content-pencil"
              />
            )}
          </div>
        </div>
      </div>
      <img
        className="printer-preview-left-image"
        src={images.printer.templates.cmf}
        alt="template-preview"
      />
    </div>
  )
}
